import PropTypes from "prop-types";
import { forwardRef } from "react";
import classes from "./Textarea.module.scss";

export const Textarea = forwardRef(
  (
    {
      label,
      name,
      placeholder,
      ignoreOffsetTop,
      required,
      noResize,
      defaultValue,
      ...props
    },
    ref
  ) => {
    return (
      <label
        data-testid={"label"}
        className={`${classes["label"]} ${ignoreOffsetTop && "mt-0"}`}
      >
        {label && (
          <div
            data-testid={"label-text"}
            className={`${classes["label-text"]} ${
              required && classes["required"]
            }`}
          >
            {label}
          </div>
        )}
        <textarea
          placeholder={placeholder}
          name={name}
          className={`${classes["textarea"]} ${
            noResize ? classes["no-resize"] : ""
          }`}
          defaultValue={defaultValue}
          required={required || false}
          ref={ref}
          {...props}
        ></textarea>
      </label>
    );
  }
);

Textarea.propTypes = {
  /**
   * name of textarea tag
   */
  name: PropTypes.string,
  /**
   * Label to be shown above the textarea
   */
  label: PropTypes.string,
  /**
   * Placeholder inside the textarea
   */
  placeholder: PropTypes.string,
  /**
   * set true to ignore margin top
   */
  ignoreOffsetTop: PropTypes.bool,
  /**
   * marks textarea as required
   */
  required: PropTypes.bool,
  //TODO: write tests for onChange
  /**
   * onChange method
   */
  onChange: PropTypes.func,
};

Textarea.defaultProps = {
  label: undefined,
  placeholder: "Input Here",
};
